$(function() {
    let $nav = $('.lSide nav'),
        $navLink = $nav.find('a'),
        page = location.pathname.split('/')[2];

    // console.log(page);
    $navLink.each(function (){
        if ($(this).attr('href') === '/style-guide/'+page+'/') $(this).addClass('ac').parents('.drop').addClass('open');
    })
});
document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('code.hljs').forEach((el) => {
        hljs.highlightElement(el);
    });
});